// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qUlw","type":"styles_type__1BkIg","choices":"styles_choices__6_Lw7"};